// Endpoint Paths
export const LOGIN = `/site/login`;
export const LOGIN_JWT = `/requestaccesstoken`;
export const LOGOUT = `/logout`;
export const REGISTER = `/site/register`;
export const FORGOT_PASSWORD = `/site/forgot-password`;
export const RESET_PASSWORD = `/site/reset-password`;
export const RESEND_CONFIRM_CODE = `/site/resend`;
export const VERIFY_REGISTRATION = `/site/verify_email`;
export const WEB_VERSION = `/site/check-web-version`

export const USER = {
  GET_ALL: `/user/all`,
  GET_PROFILE: `/user/profile`,
  UPDATE_PROFILE: `/user/update_profile`,
  UPDATE_PROFILE_DATA: `/user/update`,
  CHANGE_PASSWORD: `/user/change-password`,
  SET_PASSWORD: `/user/set-password`,
  GET_ACTIVE_PACKAGE: `/user/package`,
  GET_USER_QUOTA_USED: (id) => `/user/quota-used/${id}`,
  LOGIN_AS: (id) => `/user/loginas/${id}`,
  GET_MENTIONABLE_USERS: `/user/public`,
  SETUP_DONE: `/user/setup-done`,
  GET_USER_PROFILE: (username) => `/user/${username}`,
  GET_META: (username) => `/user/${username}/meta`,
  VIEW_SEEN_BY: (username) => `/user/${username}/seen-by`,
  CREATE: `/user/create`,
  UPGRADE: (id) => `/user/upgrade/${id}`,
};

export const UNIVERSITY = {
  GET_UNIVERSITY: `/university`,
  GET_ME: `/university/me`,
  GET_ACTIVE: `/university/active`,
  GET_PAGINATED: `/university/paginated`,
  GET_PUBLIC_PAGINATED: `/universities`,
  GET_PUBLIC_SINGLE: (slug) => `/universities/${slug}`,
  GET_PUBLIC_SINGLE_EMBED: (id) => `/embed/universities/${id}`,
  ADD_TO_ME: `/university/login`,
  SET_DEFAULT: (id) => `/university/set-default/${id}`,
  GET_CURRENT_SCHEDULE: `/university/kelasPerHari`,
  GET_WEEK_SCHEDULES: `/university/kelasPerMinggu`,
  GET_MEETING_SCHEDULES: `/university/agendaPertemuan`,
  REGISTER: `/university/register`,
  LOGOUT: `/university/remove-user`,
  GET_QUOTA_USED: (id) => `/university/quota-used/${id}`,
  UPGRADE: (id) => `/university/upgrade/${id}`,
  GET_PERIODS: `/university/periods`,
  SAVE_PERIOD: `/university/periods/save`,
  DELETE_PERIOD: (id) => `/university/periods/delete/${id}`,
  SYNC_PERIOD: `/university/periods/sync`,
  UPDATE: (id) => `/university/update/${id}`,
  QR_PRESENCE: 'university/dataQRAbsensi',
  PERSONALIZE_BRANDING: 'university/personalize-branding',
  DELETE: (id) => `/university/remove/${id}`,
};

export const NOTIFICATION = {
  GET_ALL: `/notification/all`,
  GET_COUNT_UNREAD: `/notification/total-unread`,
  SET_READ: (id) => `/notification/set-seen-by-notification-id/${id}`,
  SET_ALL_READ: `/notification/set-seen-all`,
  DELETE: (id) => `/notification/delete/${id}`
};

export const GROUP = {
  GET_DETAIL: (id) => `/group/detail/${id}`,
  GET_DETAIL_BY_CLASS_ID: (kelas_id) => `/group/classdetail/${kelas_id}`,
  GET_ALL: `/group/all`,
  GET_ALL_LISTS: `/group/all-lists`,
  GET_ACADEMIC: `/group/academic`,
  GET_ACADEMIC_LISTS: `/group/academic-lists`,
  GET_GENERAL_LISTS: `/group/general-lists`,
  GET_OWNED: `/group/me`,
  GET_PUBLIC: `/group/other`,
  GET_PAGINATED_COURSES: `/group/courses`,
  GET_MEMBERS: (id) => `/group_member/lists/${id}`,
  GET_PAGINATED_MEMBERS: (id) => `/groupmembers/${id}`,
  GET_ALL_MEMBERS: (id) => `/groupmembers/all/${id}`,
  GENERAL_CLASS_SAVE_PRESENCE:`/group/general-class/save-presence`,
  GET_MEDIAS: (id) => `/group/files/${id}`,
  SYNC_GROUP: `/group/syncGroups`,
  IMPORT: `/group/import`,
  SAVE_IMPORT: `/group/import/save`,
  ADD_GROUP: `/group/create`,
  UPDATE_GROUP: (id) => `/group/update/${id}`,
  REMOVE_GROUP: (id) => `/group/remove/${id}`,
  REMOVE_GROUP_BULK: `/group/remove-bulk`,
  JOIN_VIA_TOKEN: (token) => `/group/join/${token}`,
  JOIN_GROUP_PUBLIC: (id) => `/group/join-group-public/${id}`,
  JOIN_GROUP_PRIVATE: `/group/join-group-private`,
  GET_JOIN_REQUESTER: (group_id) => `/group-member/request/${group_id}`,
  GET_PENDING_REQUESTS: `/group-member/pendings`,
  LEAVE: (group_id) => `/group-member/leave/${group_id}`,
  ACCEPT: (gm_id, group_id) => `/group-member/accept/${gm_id}/${group_id}`,
  DECLINE: (gm_id, group_id) => `/group-member/decline/${gm_id}/${group_id}`,
  KICK: (gm_id) => `/group-member/kick/${gm_id}`,
  AS_ADMIN: (gm_id) => `/group-member/as-admin/${gm_id}`,
  AS_MEMBER: (gm_id) => `/group-member/as-member/${gm_id}`,
  GET_REPORT: (id) => `/group/report/${id}`,
  COPY: (id) => `/group/copy/${id}`,
  GET_TOTAL_CLASSES: `/group/total`,
  GET_RPS: (id) => `/group/rps/${id}`,
  SAVE_RPS: (id) => `/group/rps/${id}/save`,
  GET_USER_CLASSES_PUBLIC: (username) => `/group/${username}/public`,
  INVITE: (id) => `/group/invite/${id}`,
  GET_ALL_PAGINATED_CLASSES: `/group/siakadclasses`,
  GET_COVERS: `/group-covers`,
  GET_PROGRESS: (id) => `/group/progress/${id}`,
  GET_CERTIFICATE: `/group/certificate`,
  GENERATE_CERTIFICATE: `/group/certificate/generate`,
  GET_VIEWED_MATERIALS: (id) => `/group/viewedmaterials/${id}`,
  UPDATE_GROUP_COVER: (id) => `/group/updatecover/${id}`,
  UPDATE_GROUP_THUMBAIL: (id) => `/group/updatethumb/${id}`,
  GET_TOTAL: "/group/total",
}

export const POST = {
  GET_TIMELINE: `/post/timeline`,
  GET_ALL: (group_id) => `/post/group/${group_id}`,
  GET_DETAIL: (id) => `/post/detail/${id}`,
  ADD: (group_id) => `/post/create/${group_id}`,
  UPDATE: (post_id) => `/post/edit/${post_id}`,
  UPDATE_NEW: (post_id) => `/post/update/${post_id}`,
  DESTROY: (id) => `/post/remove/${id}`,
  ADD_COMMENT: (id) => `/comment/create/${id}`,
  UPDATE_COMMENT: (comment_id) => `/comment/edit/${comment_id}`,
  GET_COMMENTS: (id) => `/comment/post/${id}`,
  REMOVE_COMMENT: (comment_id) => `/comment/delete/${comment_id}`,
  ADD_SURVEY_RESPONSE: (group_id, survey_id) => `/survey/response/${group_id}/${survey_id}`,
  GET_MEDIA_DETAIL: (id) => `/post/media-detail/${id}`,
  SHARE_GLOBAL_TIMELINE: `/post/share`,
  SHARE_GROUP_TIMELINE: `/post/group-share`,
  GET_USER_TIMELINE_PUBLIC: (username) => `/user/${username}/posts`,
  LIKE: (id) => `/post/like/${id}`,
  GET_OPEN_ASSIGNMENTS: `/post/open-assigments`,
  RECOVER: (id) => `/post/recover/${id}`,
  GET_DESCRIPTION: (id) => `/post/description/${id}`,
}

export const MEDIA = {
  GET_ALL: `/media/all`,
  ADD: `/media/create`,
  UPLOAD: `/media/upload`,
  DOWNLOAD_MY_OWN: (id) => `/media/download/${id}/owned`,
  DOWNLOAD_SHARED_IN_CLASS: (id) => `/media/download/${id}/group`,
  DESTROY: (id) => `/media/remove/${id}`,
  GET_SELECTED: `/media/selected`,
  MOVE: (id) => `/media/move/${id}`,
  DRIVE_USAGE: `/drive/usage`,
  DRIVE: (id) => `/drive/list/${id}`,
  DRIVE_TO_MEDIA: `/drive/permission`,
  DELETE_DRIVE_MEDIA: (id) => `/drive/delete/${id}`,
  DRIVE_MEDIAS: `/drive/medias`,
  DRIVE_UPLOAD: `/drive/upload`,
  DRIVE_MEDIA_PROPERTIES: 'drive/mediaproperties',
  CONVERT_TO_ANNOTATE: `/media/convertToAnnotate`,
  CHECK_ROLE_PREVIEW: `/media/check-role-preview`,
};

export const NEWS = {
  GET_ALL: `/postnews/getallnews`,
  ADD: `/postnews/create`,
  SAVE: (id) => `/postnews/edit/${id}`,
  DELETE: (id) => `/postnews/remove/${id}`
};

export const SCHEDULE = {
  GET_DETAIL: (id) => `/schedule/show/${id}`,
  ADD_MEDIA: (id) => `/schedule/add-media/${id}`,
  REMOVE_MEDIA: (id) => `/schedule/remove-media/${id}`,
};

export const NEWS_PUBLIC = {
  GET_ALL: `/news/all`,
  GET_DETAIL: (id) => `/news/show/${id}`,
};

export const LOGS = {
  GET_NEW_USERS: `/activities/new_users`,
  GET_RECENT_ACTIVITIES: `/activities/recent_activities`,
  GET_USER_ACTIVITIES: (user_id) => `/activities/user/${user_id}`
};

export const QUIZ = {
  GET_LISTS: `/quiz/index`,
  GET_DETAIL: (id) => `/quiz/show/${id}`,
  ADD:  `/quiz/create`,
  UPDATE: (id) => `/quiz/update/${id}`,
  SAVE: (id) => `/quiz/save/${id}`,
  SHARE: (id) => `/quiz/share/${id}`,
  START: (id) => `/quiz/start/${id}`,
  RUNNING_QUIZ: (uuid, quizMemberUuid) => `/quiz/${uuid}/${quizMemberUuid}`,
  ANSWER: (question_id) => `/quiz/answer/${question_id}`,
  ANSWER_BULK: (quiz_id) => `/quiz/answer-bulk/${quiz_id}`,
  GET_RANK: (id) => `/quiz/rank/${id}`,
  GET_PAGINATED_RANK: (id) => `/quiz/rank/paginate/${id}`,
  GET_MY_RANK: (id) => `/quiz/rank/me/${id}`,
  MARK_AS: (id) => `/quiz/markas/${id}`,
  DUPLICATE: (id) => `/quiz/duplicate/${id}`,
  TRACK_FOCUS_TAB: (id) => `/quiz/trackfocustab/${id}`,
  GET_GRADE: (id) => `/quiz/grade/${id}`,
  GET_MEMBER_ANSWERS: (id) => `/quiz/memberanswers/${id}`,
  FINISH: (id) => `/quiz/finish/${id}`,
  FINISH_QUIZ: (uuid, quizMemberUuid) => `/quiz/finish/${uuid}/${quizMemberUuid}`,
  IS_DONE: (uuid, quizMemberUuid) => `/quiz/done/${uuid}/${quizMemberUuid}`,
  PROCTORING_COLLECT_MEDIA: `/quiz/proctoring/collectmedia`,
  PROCTORING_SAVE: `/quiz/proctoring/save`,
  PROCTORING_REPORT_RESULT: `/quiz/proctoring/report/result`,
  PROCTORING_REPORT_WEBCAM: `/quiz/proctoring/report/webcam`,
  SAVE_DEVICE: `/quiz/savedevice`,
};

export const QUIZ_MEMBER = {
  GET_HISTORIES: (quizId) => `/quizmember/histories/${quizId}`,
  DELETE: (memberId) => `/quizmember/delete/${memberId}`,
};

export const QUIZ_QUESTION = {
  GET_ALL: (quiz_id) => `/quiz/questions/all/${quiz_id}`,
  ADD: (quiz_id) => `/quiz/questions/create/${quiz_id}`,
  UPDATE: (quiz_id) => `/quiz/questions/update/${quiz_id}`,
  REORDER: (quiz_id) => `/quiz/questions/order/${quiz_id}`,
  DELETE: (id) => `/quiz/questions/delete/${id}`,
  IMPORT: (quiz_id) => `/quiz/questions/import/${quiz_id}`,
  EXTRACT: `/quiz/questions/extract`,
  DOWNLOAD_EXAMPLE_IMPORT: `/quiz/questions/download-example`,
};

export const SECTION = {
  GET_ALL: (group_id) => `/sections/all/${group_id}`,
  GET_DETAIL: (id) => `/sections/detail/${id}`,
  ADD: (group_id) => `/sections/create/${group_id}`,
  UPDATE: (id) => `/sections/update/${id}`,
  DELETE: (id) => `/sections/delete/${id}`,
  REORDER: (group_id) => `/sections/reorder/${group_id}`,
  DUPLICATE: (id) => `/sections/duplicate/${id}`,
  MOVE_MATERIALS: `/sections/move/materials`,
};

export const LEARNING_MATERIAL = {
  GET_ALL: (section_id) => `/learningmaterials/all/${section_id}`,
  ADD: (section_id) => `/learningmaterials/create/${section_id}`,
  GET_DETAIL: (learningmaterial_id) => `/learningmaterials/detail/${learningmaterial_id}`,
  UPDATE: (learningmaterial_id) => `/learningmaterials/update/${learningmaterial_id}`,
  DELETE: (learningmaterial_id) => `/learningmaterials/delete/${learningmaterial_id}`,
  REORDER: (section_id) => `/learningmaterials/reorder/${section_id}`,
  START_MEETING: `/learningmaterials/start-meeting`,
  DUPLICATE: (id) => `/learningmaterials/duplicate/${id}`,
  IS_JOINED_CONFERENCE: (id) => `/learningmaterials/joined/${id}`,
  DUPLICATE_ALL: `/learningmaterials/duplicateall`
};

export const ACCOUNT = {
  GET_PAGINATED: `/accounts`,
  GET_KRS: (university_id) => `/university/krs/${university_id}`,
  GET_KHS: (university_id) => `/university/khs/${university_id}`,
  GET_TRANSCRIPT: (university_id) => `/university/transcript/${university_id}`,
  GET_GRADE: (university_id) => `/university/grade/${university_id}`,
  GET_PASSWORD: (university_id) => `/accounts/password/${university_id}`,
  GET_GUIDANCE: (periode_id) => `/university/guidance/${periode_id}`,
  GET_CLASS_SECTIONS: `/university/agendaPertemuan`,
  GET_SECTION_MEMBERS: `/university/peserta`,
  SAVE_PRESENSI: `/university/massAbsenKelas`,
  LOGIN_AS: (account_id) => `/accounts/loginas/${account_id}`,
  PRESENCE_RULE_CHECK: `/university/presenceRuleCheck`,
  DESTROY: (id) => `/accounts/delete/${id}`,
}

export const MOODLE = {
  IMPORT: `/moodle/import`,
  SAVE: (group_id) => `/moodle/save/${group_id}`,
}

export const REPORT = {
  GET_UNIVERSITY_REPORTS: `/reports/universities`,
  GET_GROUP_REPORTS: `/reports/groups`,
  GET_POST_REPORTS: `/reports/posts`,
  GET_USER_STATS: `/reports/user-stats`,
  GET_POST_STATS: `/reports/post-stats`,
  GET_POSTNEWS_REPORTS: `/reports/postnews`,
  GET_COMMENT_REPORTS: `/reports/comments`,
}

export const ADMIN = {
  GET_ALL_ACADEMIC_GROUPS: `/admin/group/academic`,
  GET_ALL_TEACHERS: `/admin/account/teachers`,
  GET_ALL_STUDENTS: `/admin/account/students`,
  GET_TOTAL_CLASSES: `/admin/group/total`,
  GET_TEACHER_REPORT_ACTIVITIES: `/admin/report/teacher-posts`,
  EXPORT_POST_TEACHERS: `/admin/report/teacher-posts-export`,
  GET_REPORT_TEACHERS: `/admin/report/teachers`,
  GET_CONFERENCES: `/admin/report/conferences`,
  GET_UNIVERSITY_HOST_USAGE: `/admin/report/university-host-usage`,
  EXPORT_REPORT_TEACHERS: `/admin/report/teachers-export`,
  LOGIN_AS: (account_id) => `/admin/account/loginas/${account_id}`,
  SYNC_ACADEMIC_CLASSES: `/admin/sync`,
  GET_CLASS_ACTIVITY: '/admin/home/classactivity',
  GET_DETAIL_CLASS_ACTIVITY: (cs_id) => `/admin/home/classactivity/${cs_id}`,
}

export const TEACHER_QUESTION = {
  GET_ALL_ANSWERS: (id) => `/lecturer-question/all-answer/${id}`,
  GET_MY_ANSWER: (id) => `/lecturer-question/detail-answer/${id}`,
  ANSWER: (id) => `/lecturer-question/set-answer/${id}`,
  UPDATE_ANSWER: (tqa_id) => `/lecturer-question/edit-answer/${tqa_id}`,
  SET_GRADE: (tqa_id) => `/lecturer-question/set-grade/${tqa_id}`,
  SET_TEAM_ANSWER: `/lecturer-question/set-team-answer`,
  SET_TEAM_GRADES: `/lecturer-question/set-team-grades`,
  DOWNLOAD_ZIP: (id) => `/lecturer-question/all-answer/${id}/zip`,
  GET_FILE_SIZE: (id) => `/lecturer-question/get-file-size/${id}`,
  SAVE_ANNOTATE_FILE: '/lecturer-question/save-feedback-annotate',
  GET_ANNOTATED_FILES: (id) => `/lecturer-question/get-annotated-files/${id}`
}

export const EXPORT = {
  TEACHER_QUESTION_RESULT: (tq_id) => `/export/teacher-question-result/${tq_id}`,
  UNIVERSITY_REPORT: `/export/university-report`,
  LEARNING_REPORT: (group_id) => `/export/learning-report/${group_id}`,
}

export const ACTION = {
  TRACK: `/actions/track`,
}

export const HORIZON = {
  STATS: `/horizon/api/stats`,
  WORKLOAD: `/horizon/api/workload`,
  SUPERVISORS: `/horizon/api/masters`,
  RECENT_JOBS: `/horizon/api/jobs/recent`,
  FAILED_JOBS: `/horizon/api/jobs/failed`,
  DETAIL_FAILED_JOB: (id) => `/horizon/api/jobs/failed/${id}`,
  RETRY_FAILED_JOB: (id) => `/horizon/api/jobs/retry/${id}`
}

export const PACKAGE = {
  GET_PAGINATED: `/packages`,
  GET_UNIVERSITY_PACKAGES: `/packages/university`,
  GET_USER_PACKAGES: `/packages/user`,
  ADD: `/packages/create`,
  UPDATE: (id) => `/packages/update/${id}`,
  DELETE: (id) => `/packages/delete/${id}`,
}

export const PERMISSION = {
  GET_ALL: `/permissions`,
}

export const UNIVERSITY_NEWS = {
  GET_PUBLISHED: `/university/news/published`,
  GET_PUBLISHED_POPUP: `/university/news/published-popup`,
  GET_SINGLE: (id) => `/university/news/published/${id}`,
  GET_PAGINATED: `/university/news`,
  ADD: `/university/news/create`,
  UPDATE: (id) => `/university/news/update/${id}`,
  DELETE: (id) => `/university/news/delete/${id}`
};

export const CONVERSATION = {
  GET_PAGINATED: `/conversation/all`,
  GET_SINGLE: (id) => `/conversation/${id}`,
  GET_CONTACTS: `/conversation/contact`,
  CREATE: `/conversation/create`,
  DELETE: (id) => `/conversation/delete/${id}`
};

export const MESSAGE = {
  GET_PAGINATED: (conversation_id) => `/message/lists/${conversation_id}`,
  SEND: (conversation_id) => `/message/send/${conversation_id}`,
  SEND_TO_ADMIN: (conversation_id) => `/message/send-to-admin`,
  SET_SEEN_ALL: (conversation_id) => `/message/set-seen-all/${conversation_id}`,
};

export const CONFERENCE = {
  GET_ALL_ATTENDANCES: (post_id) => `/conferences/attendances/${post_id}`,
  ATTENDANCE: (post_id) => `/conferences/attendance/${post_id}`,
};

export const PAYMENT = {
  UPLOAD: `/paymentconfirmation`,
};

export const USER_EDUCATION = {
  GET_ALL: (username) => `/user/${username}/educations`,
  CREATE: `/user/educations/create`,
  UPDATE: (id) => `/user/educations/update/${id}`,
  DELETE: (id) => `/user/educations/delete/${id}`,
};

export const USER_EXPERIENCE = {
  GET_ALL: (username) => `/user/${username}/experiences`,
  CREATE: `/user/experiences/create`,
  UPDATE: (id) => `/user/experiences/update/${id}`,
  DELETE: (id) => `/user/experiences/delete/${id}`,
};

export const CATEGORY = {
  GET_PAGINATED: `/categories`,
};

export const USER_INTEREST = {
  GET_ALL: (username) => `/user/${username}/interests`,
  SAVE: (username) => `/user/${username}/interests/save`,
};

export const DEVICE = {
  UPDATE: `/firebase/updatetoken`
}

export const GROUP_CLIENT = {
  FETCH: (pin) => `/class/${pin}`
}

export const EDLORDER = {
  CREATE: `/edlorders/create`,
  SHOW: (id) => `/edlorders/${id}`,
  LIST: `/edlorders`,
  CANCEL: (id) => `/edlorders/cancel/${id}`,
}

export const GROUP_TEAMS = {
  GET_GROUP_MEMBERS: `/group-teams/group-members`,
  GET_SUGGESTIONS: `/group-teams/suggestions`,
  CREATE: `/group-teams/create`,
  LIST: `/group-teams`,
  DETAIL: (id) => `/group-teams/${id}`,
  UPDATE: (id) => `/group-teams/update/${id}`,
  DELETE: (id) => `/group-teams/delete/${id}`,
}

export const QUIZ_BUILDER = {
  GET_QUIZ: (postUuid) => `/quizbuilder/${postUuid}`,
  RE_ORDER_QUESTIONS: (quizUuid) => `/quizbuilder/questionreorders/${quizUuid}`,
  CREATE_QUESTION: (quizUuid) => `/quizbuilder/questions/create/${quizUuid}`,
  SAVE_QUESTION_FIELD: (questionId) => `/quizbuilder/questions/save/field/${questionId}`,
  SAVE_QUESTION_MEDIAS: (questionId) => `/quizbuilder/questions/save/medias/${questionId}`,
  DELETE_QUESTION_MEDIA: (questionId) => `/quizbuilder/questions/delete/media/${questionId}`,
  DELETE_QUESTION: (questionId) => `/quizbuilder/questions/delete/${questionId}`,
  SAVE_ANSWER_FIELD: (answerId) => `/quizbuilder/answers/save/field/${answerId}`,
  CREATE_ANSWER: (questionId) => `/quizbuilder/answers/create/${questionId}`,
  DELETE_ANSWER: (answerId) => `/quizbuilder/answers/delete/${answerId}`,
  SAVE_SETTINGS: (quizUuid) => `/quizbuilder/settings/save/${quizUuid}`,
  SHARE: (quizUuid) => `/quizbuilder/share/${quizUuid}`,
}

export const SPADA = {
  GET_ACCOUNTS: `/admin/accounts`,
  TOKEN: `/admin/token`,
  DAILY_VISITORS: `/university/stats/dailyvisitors`,
  TOP_TEN_CLASSES: `/university/stats/toptenclasses`,
  TOTAL_VISITORS: `/university/stats/totalvisitors`,
  CLASSES: `/university/stats/classes`,
  TOTAL_SUMMARY: `/university/stats/totalsummary`,
  SUMMARY: `/university/stats/summary`,
  GRAPH: `/university/stats/graph`,
  TOP_TEACHERS: `/university/stats/topteachers`,
  TOP_CLASSES: `/university/stats/topclasses`,
  TRACK: `/spada/collect`,
  GET_COURSE: '/spada/course'
}

export const INTEGRATION = {
  GOOGLE_DRIVE: (token) => `/integration/drive/connect/web?token=${token}`,
  GOOGLE_DRIVE_DISCONNECT: '/integration/drive/disconnect',
  GOOGLE_CALENDAR: (token, path = 'panel/') => `/integration/calendar/connect/web?token=${token}&from_page=${path}`,
  CONNECT: `/integration/connect`,
  TEST_ZOOM: `/integration/zoom/test`,
  DETAIL: `/integration/detail`,
  ZOOM_USAGE: `/integration/usage/zoom`,
  CALENDAR_LIST: '/integration/gcalendar/list',
  CALENDAR_DISCONNECT: '/integration/gcalendar/disconnect',
}

export const ONBOARD = {
  GET_VERIFICATION_CODE: `/onboard/get-verification-code`,
  UPDATE: `/onboard/update`,
  APPROVE_PRIVACY_POLICY: `/onboard/approve-privacy-policy`,
}

export const HOME_ADMIN = {
  CLASS_ACADEMIC_LIST: `/admin/home/academic`,
  CLASS_ACADEMIC_ACTIVITY: `/admin/home/classactivity`
}

export const LEARNING_DASHBOARD = {
  FACULTIES: '/admin/report/faculties',
  STUDY_PROGRAMS: '/admin/report/study-programs',
  CLASSES: '/admin/report/classes',
  FACULTIES_PERCENTAGE: '/admin/report/faculties-percentage',
  STUDY_PROGRAMS_PERCENTAGE: '/admin/report/study-programs-percentage',
  CLASSES_PERCANTAGE: '/admin/report/classes-percentage',
  UNIVERSITY_GRAPH: '/admin/report/graph/according-sections/university',
  FACULTY_GRAPH: '/admin/report/graph/according-sections/faculty',
  STUDY_PROGRAM_GRAPH: '/admin/report/graph/according-sections/study-programs',
  GET_SETTING: '/admin/report/settings',
  SET_THRESHOLD: '/admin/report/set-threshold'
}

export const FACULTY = {
  IS_EXISTS: '/admin/faculties/exists'
}
